// extracted by mini-css-extract-plugin
export default {"flagContainer":"Flag_flagContainer__6W3sZ"};